<template>
  <div class="app-ecommerce">
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <div
        class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3"
      >
        <div class="d-flex flex-column justify-content-center">
          <h4 class="mb-1 mt-3">Ajout d'une nouvelle marque</h4>
        </div>
        <div class="d-flex align-content-center flex-wrap gap-3">
          <div class="d-flex gap-3">
            <button
              type="submit"
              class="btn btn-primary"
              @click="dialogueConfirmationAjout()"
              :disabled="nomMarque.length == 0"
            >
              Enregistrer
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-8">
          <div class="card mb-4">
            <div class="card-header">
              <h5 class="card-tile mb-0">Information marque</h5>
            </div>
            <div class="card-body">
              <div class="mb-3">
                <H5 class="form-label">Nom </H5>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Nom marque"
                  v-model="nomMarque"
                />
                <label
                  >Le nom est la façon dont il apparaît sur votre site.</label
                >
              </div>
              <div class="row mb-3">
                <div class="col">
                  <div class="card-header" style="padding: 0.5rem">
                    <H5 class="form-label">Slug </H5>
                  </div>

                  <input
                    class="form-control"
                    placeholder="SLUG"
                    v-model="slugMarque"
                  />

                  <label
                    >Le « slug » est la version du nom normalisée pour les
                    URL.</label
                  >
                </div>
                <div class="col">
                  <div class="card-header" style="padding: 0.5rem">
                    <h5 class="form-label">Marque Parent</h5>

                    <feather-icon
                      style="color: #19b4bf; cursor: pointer"
                      icon="RefreshCcwIcon"
                      size="20"
                      v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                      v-b-tooltip.hover.v-dark
                      title="Actualisation des marques"
                      variant="gradient-primary"
                      @click="refrechMarqueParent"
                    />
                  </div>
                  <v-select
                    style="cursor: pointer"
                    :close-on-select="false"
                    :loading="marqueLoader"
                    :options="marqueParent.marques"
                    v-model="marqueSelected"
                    label="name"
                    input-id="id"
                    value="id"
                  />
                  <label
                    >Assignez un terme parent pour créer une hiérarchie.</label
                  >
                </div>
              </div>
              <div>
                <H5 class="form-label">Description </H5>
                <quill-editor v-model="descriptionMarque" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="card mb-4">
            <div class="card-header">
              <h5 class="card-title mb-0">Media</h5>
            </div>
            <div class="card-body">
              <div class="row mb-3">
                <b-overlay
                  spinner-variant="primary"
                  spinner-type="grow"
                  spinner-small
                  rounded="sm"
                  :show="imageOverlay"
                >
                  <vue-upload-multiple-image
                    v-model="imagesUrl"
                    :data-images="imagesUrl"
                    name="images"
                    drag-text="Veuillez ajoutez une images svp!"
                    browse-text="Browse image"
                    primary-text="Primary image"
                    mark-is-primary-text="Set default image"
                    :max-image="1"
                    popup-text="Description default image"
                    drop-text="Drag and drop"
                    @upload-success="uploadImageAndReturnSrc"
                    @before-remove="beforeRemove"
                    :showEdit="false"
                  >
                  </vue-upload-multiple-image>
                </b-overlay>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import { getListeMarque } from "../../views/Marques/MarqueFunction.js";
import { uploadImageSuccess } from "../../views/Products/ProductSettings/FileUpload.js";
import axios from "axios";
import websiteURL from "@/websiteURL";
import { BOverlay, VBTooltip } from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
export default {
  components: {
    quillEditor,
    VueUploadMultipleImage,
    BOverlay,
    VBTooltip,
    vSelect,
  },
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      marqueParent: [],
      marqueSelected: 0,
      marqueLoader: false,
      nomMarque: "",
      slugMarque: "",
      descriptionMarque: "",
      boxMsgAddMarque: "",
      imageOverlay: false,
      imagesUrl: [],
      marque: { image: [] },
      image: { src: "" },
      loading: false,
    };
  },
  methods: {
    async uploadImageAndReturnSrc(formData, index, fileList) {
      this.imageOverlay = true;
      try {
        const uploadedUrls = await uploadImageSuccess(
          formData,
          index,
          fileList
        );

        // Push the uploaded image URLs into the 'images' array
        this.marque.image.push(...uploadedUrls);

        this.imageOverlay = false;
      } catch (error) {
        alert("Erreur lors de l'upload de l'image:", error);
      }
    },
    beforeRemove(index, done, fileList) {
      var r = confirm("remove image");
      if (r == true) {
        done();
      } else {
      }
    },

    //Permet l'ajout d'une marque
    async addMarque() {
      if (this.marque.image[0]) {
        this.image.src = this.marque.image[0].src;
      }
      const apiUrl = websiteURL.WEBSITE + "wp-json/wc/v3/products/brands";
      const consumerKey = websiteURL.CONSUMERKEY;
      const consumerSecret = websiteURL.CONSUMERSECRET;
      try {
        const data = {
          name: this.nomMarque,
          description: this.descriptionMarque,
          slug: this.slugMarque,
          parent: this.marqueSelected.id,
          image: this.image,
        };
        const response = await axios.post(apiUrl, data, {
          auth: {
            username: consumerKey,
            password: consumerSecret,
          },
        });
        this.makeToastMsg("info");
      } catch (error) {
        alert("Erreur lors de l'ajout de la marque:", error);
      }
    },
    //Boite dialogue pour confirmer ou non l'ajout d'une marque
    dialogueConfirmationAjout() {
      this.boxMsgAddMarque = "";
      this.$bvModal
        .msgBoxConfirm("Êtes-vous sûr de vouloir ajouter la marque ?", {
          title: "Confirmation",
          size: "sm",
          okVariant: "primary",
          okTitle: this.loading ? "Loading..." : "Confirmer",
          cancelTitle: "Annuler",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.boxMsgAddMarque = value;
          if (value) {
            if (value) {
              this.loading = true;
              this.addMarque().then(() => {
                this.loading = false;
              });
            }
          }
        });
    },
    //Indique que l'ajout est bien effectuer
    makeToastMsg(variant = null) {
      this.$bvToast.toast("La marque a bien été ajouter", {
        title: `Marque ${variant || "default"}`,
        variant,
        solid: true,
        href: this.permalink,
      });
    },
    //Permet de rafraichir la liste des marque parent
    async refrechMarqueParent() {
      this.marqueLoader = true;
      this.marqueParent = await getListeMarque();
      this.marqueLoader = false;
    },
  },
  async created() {
    this.marqueParent = await getListeMarque();
  },
};
</script>
<style lang="scss">
// Style
.ql-snow {
  &.ql-container {
    .ql-editor {
      min-height: 150px;
    }
  }
}
@import "@core/scss/vue/libs/vue-select.scss";
</style>
